import { motion } from 'framer-motion';
import { FC, PropsWithChildren } from 'react';

const PageFade: FC<PropsWithChildren> = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -8 }}
    transition={{ duration: 0.4, ease: 'easeOut' }}
  >
    {children}
  </motion.div>
);

export default PageFade;
